<template>
  <div class="home">
    <carousel
      :data="slides"
      lang="en"
      :class="this.$isPC ? '' : 'sp-carousel'"
      width="530"
      height="120"
    />
    <h1 style="color: rgb(26, 87, 167)">
      呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call
    </h1>
    <news />
    <campaign-contact v-if="this.$isPC" />
    <sp-campaign-contact v-else />
    <rental v-if="this.$isPC" />
    <sp-rental v-else />
    <sp-phone-contact v-if="!this.$isPC" />
    <choices :showAll="true" />
  </div>
</template>

<script>
import Vue from 'vue'
import VueCarousel from '@chenfengyuan/vue-carousel'
import News from '@/components/modules/News'
import CampaignContact from '@/components/modules/campaign/CampaignContact'
import Rental from '@/components/modules/campaign/Rental'
import SpCampaignContact from '@/components/modules/campaign/SpCampaignContact'
import SpRental from '@/components/modules/campaign/SpRental'
import SpPhoneContact from '@/components/modules/campaign/SpPhoneContact'
import Choices from '@/components/modules/choice/Choices'
import '../../js/modernizr-custom'

Vue.component(VueCarousel.name, VueCarousel)

export default {
  components: {
    News,
    CampaignContact,
    Rental,
    SpCampaignContact,
    SpRental,
    SpPhoneContact,
    Choices,
  },
  title: '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
  meta:
    '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
  canonical:
    '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
  data() {
    return {
      slides: [
        '<div class="carousel-slide slide1"><div class="front-slide front1"></div></div>',
        '<div class="carousel-slide slide2"></div>',
        '<div class="carousel-slide slide3"></div>',
        '<div class="carousel-slide slide4"></div>',
        '<div class="carousel-slide slide5"><div class="front-slide front5"></div></div>',
      ],
    }
  },
}
</script>

<style>
.carousel {
  width: 100%;
  max-width: 1400px;
}

.sp-carousel {
  max-height: 200px;
}

.carousel-slide {
  height: 500px;

  background-repeat: no-repeat;
  background-position: 50% 80%;
  background-size: cover;
}

.sp-carousel .carousel-slide {
  max-height: 150px;
}

.carousel-slide .front-slide {
  height: 100%;

  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
}

.sp-carousel .front-slide {
  max-height: 200px;
}

.carousel-slide.slide1 {
  background-image: url('../../assets/scene1.jpg');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide2 {
  background-image: url('../../assets/slide2.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide3 {
  background-image: url('../../assets/slide3.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide4 {
  background-image: url('../../assets/slide4.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide5 {
  background-image: url('../../assets/scene4.jpg');
  width: 100%;
  height: 500px;
}

.front-slide.front1 {
  background-image: url('../../assets/s1.png');
}

.front-slide.front5 {
  background-image: url('../../assets/s5.png');
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue